// import { SUPPORTS_STICKY } from '../util/SUPPORTS_STICKY.js';
// import clamp from '../util/clamp.js';

// if (SUPPORTS_STICKY) {

    /**
     * We fade elements in on scroll using an IntersectionObserver. Rather than
     * relying on a scroll event, the IntersectionObserver fires when the given
     * thresholds are met. By paying closer attention as more of the element is
     * visible, we can save processing power.
     */
    const dateElement = document.querySelector('.js-date');

    let observer = new IntersectionObserver((entries) => {

        entries.forEach(({ target, intersectionRatio }) => {
            
            // const opacity = clamp(0, (intersectionRatio - 0.35) * 2, 1);
            let opacity;
            if (intersectionRatio) {
                opacity = 1;
            } else {
                opacity = 0.3;
            }

            target.style.opacity = opacity;

            if ( opacity == 1 ) {
                dateElement.textContent = target.dataset.date;
            }
        });
    }, {
        rootMargin: '-55% 0% -44% 0%',
        threshold: [
            0, 0.2, 0.4, 0.5, 0.6, 0.7,
            0.8, 0.825, 0.85, 0.875,
            0.9, 0.925, 0.95, 0.975,
            1,
        ],
    });

    $('.js--proav--fade-scroll')
        .addClass('sticky')
        .each((ignore, element) => {
            observer.observe(element);
        })
        .closest('.vertical-detail')
        .addClass('sticky');

// }



// WEBPACK FOOTER //
// ./scripts/gutenberg_components/_title-copy-list.js